import React from "react";
import "../styles/MarkColorPicker.css";
import {
  getMarkColorStyle,
  resolveMarkColor,
} from "../utils/markColors";

export const MarkColorPicker = ({ value, onChange, className = "" }) => (
  <label
    className={`mark-color-control ${className}`.trim()}
    title="Farbe auswählen"
  >
    <input
      type="color"
      className="mark-color-picker"
      value={resolveMarkColor(value)}
      onChange={event => onChange(event.target.value)}
      aria-label="Markenfarbe auswählen"
    />
  </label>
);

export const MarkColorBadge = ({ value }) => (
  <span
    className="mark-color-badge"
    style={getMarkColorStyle(value)}
    role="img"
    aria-label="Gewählte Farbe"
    title="Gewählte Farbe"
  />
);
